module.exports = __webpack_public_path__ + "static/media/marker.582ef1da.svg";